"use client";

import { usePathname, useRouter } from "next/navigation";
import { useState } from "react";

import { Button } from "@/components/buttons/Button";
import { TextLink } from "@/components/links/TextLink";
import { Modal } from "@/components/Modal";
import { NormalText } from "@/components/text/NormalText";
import { createStripePortalAction } from "@/data/payment/actions/createStripePortalAction";

// The overdue decision is made on the server (isUserPaymentOverdue in the application layout) because it depends on who the user is, which stays server knowledge.
export function PaymentOverdueModal({
  isPaymentOverdue,
}: {
  isPaymentOverdue: boolean;
}) {
  const router = useRouter();
  const pathname = usePathname();

  const [isLoading, setIsLoading] = useState(false);

  const isAccountPage = pathname === "/account";
  const shouldShowModal = isPaymentOverdue && !isAccountPage;

  const handleUpdatePaymentMethod = async () => {
    try {
      setIsLoading(true);
      const stripePortalUrl = await createStripePortalAction({
        typeOfPortal: "paymentMethodUpdate",
        stripeIdPriceForSubscriptionUpdateConfirm: null,
      });

      if (stripePortalUrl !== null) {
        router.push(stripePortalUrl);
      }
    } catch (error) {
      console.error("Error updating payment method", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={shouldShowModal}
      closeModal={null}
      title="Payment failed"
      widthMode="normal"
    >
      <NormalText elementType="p" className="mb-4">
        We couldn't process your payment. Please update your billing information
        and retry charge.
      </NormalText>
      <Button
        className="w-full"
        onClick={handleUpdatePaymentMethod}
        loading={isLoading}
      >
        Update payment
      </Button>
      <TextLink href="/account" external={false} className="mt-4 block">
        Manage billing →
      </TextLink>
    </Modal>
  );
}
